import { useMemo } from "react";
import useGameStore from "@store/useGameStore";
import useSelectionStore from "@store/useSelectionStore";
import { ClickDTO } from '@models/ClickDTO';
import { ClickableType } from '@utils/enums';
import EnergyDisplay from "@components/ui/game/energy-display/EnergyDisplay";
import UnitIcon from '@gameobjects/UnitIcon';
import "./DeployableUnitsPanel.css";

export default function DeployableUnitsPanel() {
  const currentClick = useSelectionStore((state) => state.currentClick);
  const handleClick = useSelectionStore((state) => state.handleClick);

  // Get deployable units
  const deployableUnits = useMemo(() => {
    try {
      return useGameStore.getState().getDeployableUnits();
    } catch (error) {
      console.error('[DeployableUnitsPanel] Error getting deployable units:', error);
      return [];
    }
  }, []);

  // Get deployed units to filter
  const deployedUnits = useGameStore((state) => state.getCurrentUnits());

  // Filter out already deployed units
  const availableUnits = useMemo(() => {
    const deployedIds = new Set(deployedUnits.map(u => u.id));
    return deployableUnits.filter(unit => !deployedIds.has(unit.id));
  }, [deployableUnits, deployedUnits]);

  if (availableUnits.length === 0) {
    return null; // Don't show panel if no units to deploy
  }

  return (
    <div className="deployable-units">
      <h4>Deployable Units</h4>
      <ul>
        {availableUnits.map((unit) => {
          const isSelected = currentClick?.data?.id === unit.id;

          const handleUnitClick = () => {
            const clickDTO = new ClickDTO(ClickableType.DEPLOYABLE, unit, 'DeployableUnitsPanel');
            handleClick(clickDTO);
          };

          return (
            <li
              key={unit.id}
              className={`btn-selectable unit-card${isSelected ? " selected" : ""}`}
              onClick={handleUnitClick}
            >
              <UnitIcon unitId={unit.id} size="small" clickable={false} />
              <span className="unit-name">{unit.name}</span>
              {unit.unit_template?.energy_deploy_cost != null && (
                <EnergyDisplay value={unit.unit_template.energy_deploy_cost} size="tiny" />
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
